import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-Home",
  "use": "icon-Home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Home\"><defs><style type=\"text/css\"></style></defs><path d=\"M0.768 290.56L514.816 0.832l508.16 300.16-45.248 76.544-464-274.112L44.48 368zM598.464 800.64h88.96V489.6H598.4v311.04z m-264.768 0h88.896V489.6h-88.96v311.04z\" p-id=\"16718\" /><path d=\"M200.32 400.64v488.96h622.272V400.64h88.896v577.856h-800V400.64z\" p-id=\"16719\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol